/* LEGAL-NOTICE
   © Copyright 2018 - Quid Informatica S.p.A. - All Rights Reserved
   https://quidinfo.it/qinetic/licence.html - "Quid Consumer Lending Platform"
   Deposito SIAE n. 012702 del 26 Luglio 2018
LEGAL-NOTICE */
import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-amount-counter',
  templateUrl: './amount-counter.component.html',
  styleUrls: ['./amount-counter.component.scss'],
  standalone: false
})
export class AmountCounterComponent implements OnInit {
  /**
   * importo
   */
  @Input() amount = 0;

  /**
   * durata animazione in secondi
   */
  @Input() duration = 1;

  /**
   * frequenza di aggiornamento in secondi
   */
  @Input() frequency = 0.05;

  /**
   * formato di visualizzazione del numero
   */
  @Input() format = '2.2-2';

  /**
   * importo visualizzato
   */
  frontAmount = 0;

  /**
   * durata in millisecondi dell'animazione
   */
  private msDuration: number;

  /**
   * frequenza in millisecondi di aggionramento
   */
  private msFrequency: number;

  /**
   * valore di incremento ad ogni refresh
   */
  private increment: number;

  /**
   * interval
   */
  private interval;

  ngOnInit() {
    if (this.amount <= 0) {
      return;
    }

    this.startCount();
  }

  startCount(): void {
    this.frontAmount = 0;

    this.calcDuration();
    this.calcFrequency();
    this.calcIncrement();

    this.interval = setInterval(() => {
      this.updateCount();
    }, this.msFrequency);
  }

  stopCount(): void {
    clearInterval(this.interval);
    this.interval = undefined;
  }

  private updateCount(): void {
    if (this.isEqual()) {
      this.frontAmount = this.amount;
      this.stopCount();
      return;
    }

    this.frontAmount += this.increment;
  }

  private calcDuration(): void {
    this.msDuration = this.duration * 1000;
  }

  private calcFrequency(): void {
    this.msFrequency = this.frequency * 1000;
  }

  private calcIncrement(): void {
    this.increment = this.amount / (this.msDuration / this.msFrequency);
  }

  private isEqual(): boolean {
    return this.frontAmount >= this.amount;
  }
}
